import { types } from 'mobx-state-tree';

import { IsoDate } from '../../../common/v1';
import { AttachmentTypeEnum } from '../definitions/AttachmentType';


const Attachment = types
    .model('Attachment', {
        id: types.identifier,
        filename: types.string,
        mediaType: types.string,
        created: IsoDate,
        comments: types.string,
        bundleID: types.string,
        submitted: types.boolean,
        attachmentType: AttachmentTypeEnum,
        deleted: false,
    })
    .actions(self => ({
        setSubmitted(submitted) {
            self.submitted = submitted;
        },
    }));

export default Attachment;
